import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withCtx as _withCtx, createVNode as _createVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "innerAssets" }

import { ref } from 'vue';

interface Prop {
  startIdx?: number
}

export default /*#__PURE__*/_defineComponent({
  __name: 'defaultCarousel',
  props: {
    startIdx: null
  },
  setup(__props: any) {

const prop = __props as {
  startIdx?: number
};



const slide = ref(prop.startIdx ?? 1)

return (_ctx: any,_cache: any) => {
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_carousel = _resolveComponent("q-carousel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_q_carousel, {
      animated: "",
      modelValue: slide.value,
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((slide).value = $event)),
      navigation: "",
      infinite: "",
      autoplay: 5000,
      "transition-prev": "slide-right",
      "transition-next": "slide-left",
      height: "100%"
    }, {
      "navigation-icon": _withCtx(({ active, btnProps, onClick }) => [
        active
          ? (_openBlock(), _createBlock(_component_q_btn, {
              key: 0,
              size: "5pt",
              icon: btnProps.icon,
              color: "primary",
              flat: "",
              round: "",
              dense: "",
              onClick: onClick
            }, null, 8, ["icon", "onClick"]))
          : (_openBlock(), _createBlock(_component_q_btn, {
              key: 1,
              size: "5pt",
              icon: btnProps.icon,
              color: "grey-5",
              flat: "",
              round: "",
              dense: "",
              onClick: onClick
            }, null, 8, ["icon", "onClick"]))
      ]),
      default: _withCtx(() => [
        _renderSlot(_ctx.$slots, "default")
      ]),
      _: 3
    }, 8, ["modelValue"])
  ]))
}
}

})